// Backend datetime columns (e.g. group_members.muted_until) are naive and
// stored/interpreted as UTC (confirmed: the API container runs in UTC and
// Pydantic serializes naive datetimes with no trailing 'Z'/offset, e.g.
// "2026-07-19T20:23:10.296901"). `new Date(...)` on a date-time string with
// no timezone designator is parsed as the BROWSER's local time, not UTC --
// silently shifting the real instant by the viewer's UTC offset. Append 'Z'
// before parsing so it's read as the UTC instant it actually is.
export const parseUtcDate = (isoString) => {
  if (!isoString) return null;
  const hasDesignator = /Z$|[+-]\d{2}:?\d{2}$/.test(isoString);
  return new Date(hasDesignator ? isoString : `${isoString}Z`);
};
